(function () {
  'use strict';

  class RhfTabbedProducts {
    static selector = '[data-rhf-tabbed-products]';
    static instanceKey = '__rhfTabbedProducts';

    constructor(section) {
      this.section = section;
      this.boundClick = this.handleClick.bind(this);
      this.boundKeydown = this.handleKeydown.bind(this);
    }

    init() {
      if (!this.section || this.section[RhfTabbedProducts.instanceKey]) return;

      this.section[RhfTabbedProducts.instanceKey] = this;
      this.section.addEventListener('click', this.boundClick);
      this.section.addEventListener('keydown', this.boundKeydown);
      this.syncVideo();
    }

    destroy() {
      if (!this.section) return;

      this.pauseVideos();
      this.section.removeEventListener('click', this.boundClick);
      this.section.removeEventListener('keydown', this.boundKeydown);
      this.section[RhfTabbedProducts.instanceKey] = null;
    }

    handleClick(event) {
      const link = event.target.closest('[data-rhf-tab-link]');
      if (!link || !this.section.contains(link)) return;

      event.preventDefault();
      this.activate(link.getAttribute('data-rhf-tab-link'));
    }

    handleKeydown(event) {
      const link = event.target.closest('[data-rhf-tab-link]');
      if (!link || !this.section.contains(link)) return;
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

      const links = this.getTabLinks();
      const currentIndex = links.indexOf(link);
      if (currentIndex < 0) return;

      event.preventDefault();

      const direction = event.key === 'ArrowRight' ? 1 : -1;
      const nextIndex = (currentIndex + direction + links.length) % links.length;
      const nextLink = links[nextIndex];

      nextLink.focus();
      this.activate(nextLink.getAttribute('data-rhf-tab-link'));
    }

    activate(tabId) {
      if (!tabId) return;

      this.getTabLinks().forEach((link) => {
        const isActive = link.getAttribute('data-rhf-tab-link') === tabId;
        link.classList.toggle('is-active', isActive);
        link.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.getPanels().forEach((panel) => {
        const isActive = panel.getAttribute('data-rhf-tab-panel') === tabId;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });

      this.syncVideo();
    }

    getTabLinks() {
      return Array.from(this.section.querySelectorAll('[data-rhf-tab-link]'));
    }

    getPanels() {
      return Array.from(this.section.querySelectorAll('[data-rhf-tab-panel]'));
    }

    pauseVideos() {
      this.section.querySelectorAll('video').forEach((video) => {
        try {
          video.pause();
          video.currentTime = 0;
        } catch (error) {
          // Browser autoplay policies can reject media operations.
        }
      });
    }

    syncVideo() {
      this.pauseVideos();

      const activeVideo = this.section.querySelector('[data-rhf-tab-panel].is-active video');
      if (!activeVideo) return;

      const playPromise = activeVideo.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch(() => {});
      }
    }
  }

  function initSections(root) {
    const scope = root || document;

    scope.querySelectorAll(RhfTabbedProducts.selector).forEach((section) => {
      const instance = new RhfTabbedProducts(section);
      instance.init();
    });
  }

  function destroySection(root) {
    if (!root) return;

    const section = root.matches && root.matches(RhfTabbedProducts.selector)
      ? root
      : root.querySelector && root.querySelector(RhfTabbedProducts.selector);

    if (section && section[RhfTabbedProducts.instanceKey]) {
      section[RhfTabbedProducts.instanceKey].destroy();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSections());
  } else {
    initSections();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initSections(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    destroySection(event.target);
  });
})();
